import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION3: PdfComponent = {
  type: 'section',
  id: 'iars3',
  title: '3. Scope of Activities',
  content: [
    {
      type: 'bulletList',
      id: 'iars3bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Introducer is authorised to:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Effect introductions to the Principal or its Group; and',
              },
              {
                copy: {
                  type: 'altText',
                  id: 'iars3promo',
                  content: [
                    'Distribute ',
                    'Non-real time Financial Promotions',
                    ' approved in writing by the Principal',
                  ],
                  boldFirst: false,
                },
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: ['The Introducer is ', 'not', ' authorised to:'],
            boldFirst: false,
          },
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Provide financial advice or undertake regulated activities beyond what is expressly permitted;',
              },
              {
                copy: 'Issue or approve Financial Promotions independently;',
              },
              {
                copy: 'Receive client monies.',
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              'The Introducer must comply with all applicable ',
              'laws, FCA rules, and guidance',
              ', and all compliance procedures issued by the Principal.',
            ],
            boldFirst: false,
          },
        },
      ],
      prefix: '3',
    },
  ],
};
